export default __webpack_public_path__ + "static/media/icon-info-filled.d4a22d40.svg";